import React, { useState } from "react";
import CisList from "./CisList";
import LoadSimple from "../../LoadSimple";
import { lang } from "../../generales/traduction";
import { capitalizeFirstLetter } from "../../../utils/utils";
const TableCis = ({
  pageActual,
  limitList,startLimit,
  devices,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  languaje,
  handleShowPopup,
  mode
}) => {
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
      <div className="field-head-table-cis field-larger">Logo</div>
        <div className="field-head-table-cis field-medium">Software-ID</div>
        
        <div className="field-head-table-cis field-larger" style={{width:'20%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])}</div>
        <div className="field-head-table-cis field-larger" style={{width:'20%'}}>{capitalizeFirstLetter(lang[languaje]['operativeSistem'])}</div>
        <div className="field-head-table-cis field-larger" style={{width:'20%'}}>{'Version '}</div>
        

        <div className="field-head-table-cis field-larger" style={{width:'30%'}}>{capitalizeFirstLetter(lang[languaje]['acciones'])}</div>
        </div>
      </div>
      <div className="body-table-cis-gs">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <CisList
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
            handleShowPopup={handleShowPopup}
          ></CisList>
        )}
      </div>
    </div>
  );
};

export default TableCis;
